<template>
  <div class="shade-chil">
    <div style="height: 578px border-bottom: 1px solid #ddd">
      <div class="resource">
        <div
          id="resourceList"
          class="resourceList"
          v-loading="loadingFlag"
          :element-loading-text="$t('message.拼命加载中')"
          element-loading-spinner="el-icon-loading"
        >
          <el-table
            ref="singleTable"
            :data="getTableData"
            tooltip-effect="dark"
            style="width: 100%"
            height="558"
            highlight-current-row
            @selection-change="handleCurrentChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>

            <el-table-column label="No." type="index" width="55">
            </el-table-column>

            <el-table-column
              sortable
              prop="backaccountid"
              label="ID"
              width="100"
            >
            </el-table-column>

            <el-table-column
              sortable
              prop="workname"
              :label="$t('message.工作名')"
              min-width="100"
            >
            </el-table-column>

            <el-table-column
              sortable
              prop="contact"
              :label="$t('message.联系方式')"
              min-width="100"
            >
            </el-table-column>

            <el-table-column width="150" sortable :label="$t('message.员工状态')">
              <template slot-scope="scope">
                <span>{{ $t(`message.${getAccountStateName(scope.row.state)}`) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- <div class="myObject">{{ getTableData().length }} 个项目</div> -->

    <div class="on-btn">
      <el-button
        type=""
        size="mini"
        @click="getList"
        icon="el-icon-refresh"
        round
        >{{$t('message.刷新')}}</el-button
      >
      <el-button
        type=""
        size="mini"
        icon="el-icon-close"
        round
        @click="onCancel"
        >{{$t('message.关闭')}}</el-button
      >
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-check"
        round
        @click="onAppend"
        >{{$t('message.选择')}}</el-button
      >
    </div>
  </div>
</template>

<script>
import shade from "@/components/shade/shade";
import commonUtil from "@/utils/commonUtil";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "EmployeeStore",

  components: {
    shade,
  },

  props: {
    // 排除对象列表
    excludeList: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      tableData: [],
      loadingFlag: false,
      currentRow: [],
    };
  },

  methods: {
    onAppend() {
      this.$emit("onAppendEmployee", this.currentRow);
    },

    onCancel() {
      this.$emit("onCancelAppenEmployee");
    },

    handleCurrentChange(val) {
      this.currentRow = val;
    },

    getAccountStateName(state) {
      return commonUtil.getAccountStateName(state);
    },

    getAccountGenderName(gender) {
      return commonUtil.getGenderName(gender);
    },

    getAccountAuthName(auth) {
      return commonUtil.getAccountAuthName(auth);
    },

    getList() {
      this.loadingFlag = true;
      rejecthttp(true,'get',"/manage/organization/employee/getlist",{
            appid: 188,
          },this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
              console.log(1111);
            this.tableData = doc.data.data;
            }
            })
      // this.$http
      //   .get("/manage/organization/employee/getlist", {
      //     params: {
      //       appid: 188,
      //     },
      //   })
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.tableData = doc.data.data;
      //     }
      //   });
      this.loadingFlag = false;
    },
  },

  computed: {
    getTableData() {
      for (let i = 0; i < this.tableData.length; i++) {
        this.excludeList.forEach((element) => {
          if (this.tableData[i].backaccountid == element.backaccountid) {
            this.tableData.splice(i, 1);
          }
        });
      }
      return this.tableData;
    },
  },
  created() {
    this.getList();
  },
  mounted() {},

  watch: {
    excludeList: {
      handler(val, oldVal) {
        this.getList();
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.myObject {
  position: absolute;
  left: 22px;
  bottom: 20px;
  color: #303133;
}

.on-btn {
  position: absolute;
  bottom: 20px;
  right: 30px;
}

.resource-title {
  position: absolute;
  top: 15px;
  left: 48px;
  font-size: 18px;
  font-family: "微软雅黑";
  color: #303133;
  font-weight: 600;
}

.resource-icon {
  position: relative;
  top: -7px;
  font-size: 27px;
  color: #303133;
  margin-bottom: 20px;
}

.resource-icon:after {
  position: absolute;
  content: "";
  display: block;
  height: 90%;
  width: 0;
  border-left: 3px solid #303133;
  left: -10px;
  top: 2px;
}

.resource {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
}

.shade-chil {
  width: 1050px;
  height: 680px;
  /* background-color: RGB(249,249,249); */
  border-radius: 12px;
  box-shadow: 4px 4px 12px #888888;
  background-image: linear-gradient(#f9f9f9, #fdfdfd, #f0f0f0, #f3f3f3);

  border-left: 1px solid #bbb;
  border-top: 1px solid #bbb;
  border-right: 1px solid #888;
  border-bottom: 1px solid #888;
  padding: 20px;
  position: relative;
  z-index: 100;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.shade-chil .listBtn-box {
  position: absolute;
  width: 670px;
  height: 30px;
  line-height: 30px;
  /* border-right: 1px solid #ddd; */
  /* border-left   1px solid #ddd */
  padding-left: 10px;
  top: -37px;
  left: 3px;
  z-index: 1000;
}
.shade-chil .listBtn-box span a {
  color: #303133;
  font-size: 10px;
}

.shade-chil .listBtn-box span i {
  color: #303133;
  font-size: 10px;
}
.resource {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  /* top: 70px; */
  width: 100%;
  /* height 505px */
  /* border-top: 1px solid #ddd; */
  /* border-bottom  1px solid #ddd */
}

.seek-box {
  position: absolute;
  width: 330px;
  height: 40px;
  top: -42px;
  right: 0px;
  z-index: 10;
}

.seek-box /deep/ .el-input__inner {
  height: 35px;
}

.seek-main {
  width: 80%;
  height: 40px;
  font-size: 14px;
  color: #888;
  border: none;
}

.seek-icon {
  font-size: 28px;
  cursor: pointer;
  color: #303133;
  position: relative;
  top: 5px;
  margin-left: 0.1em;
}

.resourceList {
  width: 100%;
  height: 560px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* align-content: center; */
  align-content: flex-start;
  /* position: relative; */
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding-left: 20px;
}

.renameTextArea {
  position: relative;
  width: 80px;
  resize: none;
  overflow: visible;
  height: auto;
  background-color: #fff;
  z-index: 1001;
}

.renameTextAreaDialog {
  position: relative;
  width: 350px;
  height: 80px;
  resize: none;
  overflow: visible;
  background-color: #fff;
  border: 1px solid #ddd;
  z-index: 1001;
}
</style>



// WEBPACK FOOTER //
// src/components/Organization/EmployeeStore.vue